import { TFunction } from 'next-i18next'

import { Payment } from '~/types/payment'
import { ProductCategory } from '~/types/tutoring-api'

export function generateReceiptProductLabel(receipt: Payment, t: TFunction): string {
  if (receipt.productCategory === ProductCategory.TUTORING) {
    return `${t(`booking:tutorLevel.${receipt.mentorLevel}` as const)}, ${receipt.hours} ${t('generics:hours')}`
  } else if (receipt.productCategory === ProductCategory.VIDEO_CHAT) {
    return `${t('generics:videoChat')}, ${receipt.minutes} ${t('generics:minutes')}`
  } else {
    return ''
  }
}
